import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import {
  CanMatchFn,
  Router,
  UrlSegmentGroup,
  defaultUrlMatcher
} from '@angular/router';
import { INSTANCE_CODE } from '@konnektu/tokens';
import { catchError, map, of } from 'rxjs';
import { CardViewService } from './card-view.service';

export const dynamicCardCanMatchGuard: CanMatchFn = (route, segments) => {
  const cardViewService = inject(CardViewService);
  const router = inject(Router);
  const tenantCode = inject(INSTANCE_CODE);

  return cardViewService.getViews('card').pipe(
    map((views) =>
      views.some((view) => {
        const segmentGroup = new UrlSegmentGroup(segments, {});
        const res = defaultUrlMatcher(segments, segmentGroup, {
          path: view.Path
        });
        return !!res;
      })
    ),
    catchError((error) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        const redirectUrl = router.createUrlTree([tenantCode, 'login'], {
          queryParams: { to: [tenantCode, ...segments.join('/')] }
        });
        return router.navigateByUrl(redirectUrl);
      }
      return of(false);
    })
  );
};
